import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superAdminClubManagementRoutes = [
  {
    path: 'clubs',
    component: DummyRouter,
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.SuperAdminLimitedClubsView,
    },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/superAdmin/clubManagement/list/SuperAdminClubManagementListView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedClubsView,
        },
      },
      {
        path: ':clubId/codes/:id',
        component: () => import('@/features/superAdmin/tenantCodes/TenantCodeDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsCodesView,
        },
      },
      {
        path: ':clubId/groups/:id',
        component: () => import('@/features/superAdmin/tenantGroups/TenantGroupDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsGroupsView,
        },
      },
      {
        path: ':clubId/terms/:id',
        component: () => import('@/features/superAdmin/tenantTerms/TenantTermDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsTermsView,
        },
      },
      {
        path: ':clubId/term-groups/:id',
        component: () => import('@/features/superAdmin/tenantTermGroups/TenantTermGroupDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsTermGroupsView,
        },
      },
      {
        path: ':clubId',
        component: () =>
          import('@/features/superAdmin/clubManagement/edit/SuperAdminClubManagementEditView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedClubsView,
        },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/superAdmin/clubManagement/edit/SuperAdminClubManagementEditView.vue'),
        meta: {
          fullSuperAdminOnly: true,
        },
      },
    ],
  },
]
